import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import LoginCarousel from './LoginCarousel';
import { userActions } from '../../_actions';
import './auth.css';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      password: '',
      confirmPassword: '',
      passwordError: '',
      confirmPasswordError: '',
      error: '',
      isLoading: false,
      success: false,
      showPassword: false,
      showConfirmPassword: false
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    this.toggleConfirmPasswordVisibility = this.toggleConfirmPasswordVisibility.bind(this);
  }

  componentWillUnmount() {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ 
      [name]: value,
      [`${name}Error`]: '',
      error: ''
    });
  }

  togglePasswordVisibility() {
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  toggleConfirmPasswordVisibility() {
    this.setState(prevState => ({ showConfirmPassword: !prevState.showConfirmPassword }));
  }

  handleSubmit(e) {
    e.preventDefault();
    
    const { password, confirmPassword } = this.state;
    const token = this.props.match.params.token;
    
    // Validation
    if (!password) {
      this.setState({ passwordError: 'Please enter a new password' });
      return;
    }
    
    if (password.length < 6) {
      this.setState({ passwordError: 'Password must be at least 6 characters' });
      return;
    }
    
    if (!confirmPassword) {
      this.setState({ confirmPasswordError: 'Please confirm your password' });
      return;
    }
    
    if (password !== confirmPassword) {
      this.setState({ confirmPasswordError: 'Passwords do not match' });
      return;
    }

    this.setState({ isLoading: true });

    const params = {
      password: password,
      deviceToken: 'web',
      deviceTypeId: 2,
      resetToken: token
    };

    this.props.dispatch(userActions.reset(params))
      .then((response) => {
        this.setState({ isLoading: false });
        
        if (response.data.errorCode === 0 || response.data.statusCode === 1) {
          this.setState({ success: true });
          this.redirectTimer = setTimeout(() => {
            if (this.props.history) {
              this.props.history.push('/login');
            }
          }, 2500);
        } else {
          this.setState({
            error: response.data.messages || response.data?.error?.errorMessage || 'Failed to reset password. Please try again.'
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          error: 'An error occurred. Please try again.'
        });
      });
  }

  renderSuccessView() {
    return (
      <div className="auth-form-container">
        <div className="auth-success-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="32" fill="#10B981" fillOpacity="0.1"/>
            <path d="M20 32L28 40L44 24" stroke="#10B981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h2 className="auth-title">Password Reset Successfully!</h2>
        <p className="auth-subtitle">
          Your password has been updated. Redirecting you to sign in&hellip;
        </p>

        <Link to="/login" className="auth-btn auth-btn-primary auth-btn-block">
          Sign In Now
        </Link>
      </div>
    );
  }

  renderFormView() {
    const { password, confirmPassword, passwordError, confirmPasswordError, error, isLoading, showPassword, showConfirmPassword } = this.state;

    return (
      <div className="auth-form-container">
        <Link to="/login" className="auth-back-btn">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Back to Login
        </Link>

        <h2 className="auth-title">Reset your password</h2>
        <p className="auth-subtitle">
          Enter your new password below to complete the reset process.
        </p>

        {error && (
          <div className="auth-error-message">
            {error}
          </div>
        )}

        <form onSubmit={this.handleSubmit}>
          <div className="auth-form-group">
            <label className="auth-label">New Password</label>
            <div className="auth-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                className={`auth-input ${passwordError ? 'auth-input-error' : ''}`}
                placeholder="Enter new password"
                value={password}
                onChange={this.handleChange}
                autoComplete="new-password"
              />
              <button
                type="button"
                className="auth-input-toggle"
                onClick={this.togglePasswordVisibility}
                tabIndex="-1"
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2.5 10C2.5 10 5 4.16667 10 4.16667C15 4.16667 17.5 10 17.5 10C17.5 10 15 15.8333 10 15.8333C5 15.8333 2.5 10 2.5 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M8.82 8.82C8.50461 9.08523 8.26824 9.43446 8.13752 9.82949C8.0068 10.2245 7.98687 10.6494 8.08 11.0556C8.17313 11.4618 8.37568 11.8329 8.66484 12.1271C8.954 12.4213 9.31858 12.6271 9.72 12.7222C10.1214 12.8173 10.5421 12.7978 10.9333 12.6659C11.3245 12.534 11.6706 12.2951 11.9333 11.9778" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14.95 14.95C13.5255 16.0358 11.7909 16.6374 10 16.6667C4.16667 16.6667 0.833336 10 0.833336 10C1.86991 8.06825 3.30762 6.38051 5.05 5.05M8.25 3.53333C8.82361 3.39907 9.41093 3.33195 10 3.33333C15.8333 3.33333 19.1667 10 19.1667 10C18.6608 10.9463 18.0575 11.8373 17.3667 12.6583" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M0.833336 0.833336L19.1667 19.1667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>
            </div>
            {passwordError && (
              <span className="auth-error-text">{passwordError}</span>
            )}
          </div>

          <div className="auth-form-group">
            <label className="auth-label">Confirm New Password</label>
            <div className="auth-input-wrapper">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                name="confirmPassword"
                className={`auth-input ${confirmPasswordError ? 'auth-input-error' : ''}`}
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={this.handleChange}
                autoComplete="new-password"
              />
              <button
                type="button"
                className="auth-input-toggle"
                onClick={this.toggleConfirmPasswordVisibility}
                tabIndex="-1"
              >
                {showConfirmPassword ? (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2.5 10C2.5 10 5 4.16667 10 4.16667C15 4.16667 17.5 10 17.5 10C17.5 10 15 15.8333 10 15.8333C5 15.8333 2.5 10 2.5 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M8.82 8.82C8.50461 9.08523 8.26824 9.43446 8.13752 9.82949C8.0068 10.2245 7.98687 10.6494 8.08 11.0556C8.17313 11.4618 8.37568 11.8329 8.66484 12.1271C8.954 12.4213 9.31858 12.6271 9.72 12.7222C10.1214 12.8173 10.5421 12.7978 10.9333 12.6659C11.3245 12.534 11.6706 12.2951 11.9333 11.9778" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14.95 14.95C13.5255 16.0358 11.7909 16.6374 10 16.6667C4.16667 16.6667 0.833336 10 0.833336 10C1.86991 8.06825 3.30762 6.38051 5.05 5.05M8.25 3.53333C8.82361 3.39907 9.41093 3.33195 10 3.33333C15.8333 3.33333 19.1667 10 19.1667 10C18.6608 10.9463 18.0575 11.8373 17.3667 12.6583" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M0.833336 0.833336L19.1667 19.1667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>
            </div>
            {confirmPasswordError && (
              <span className="auth-error-text">{confirmPasswordError}</span>
            )}
          </div>

          <div className="auth-password-requirements">
            <p className="auth-text-muted auth-text-sm">
              Password must be at least 6 characters long
            </p>
          </div>

          <button 
            type="submit" 
            className="auth-btn auth-btn-primary auth-btn-block"
            disabled={isLoading}
          >
            {isLoading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>

        <div className="auth-divider">
          <span>or</span>
        </div>

        <div className="auth-text-center">
          <span className="auth-text-muted">Remember your password? </span>
          <Link to="/login" className="auth-link">
            Sign in
          </Link>
        </div>
      </div>
    );
  }

  render() {
    const { success } = this.state;

    return (
      <AuthLayout rightPanel={<LoginCarousel />}>
        {success ? this.renderSuccessView() : this.renderFormView()}
      </AuthLayout>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(ResetPassword);